module.exports = __webpack_public_path__ + "static/media/KioskSurveyScreen.7427c5cb.png";